import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  TextField,
  Grid,
  Typography
} from '@material-ui/core';
import { saveDataMappingRequestSkuEmailDataApi } from 'api';
import { Formik } from 'formik';
import * as yup from 'yup';
import useStyles from './styles';


const validationSchema = yup.object().shape({
  revenueCategory1: yup.string().required('Field is required'),
  revenueCategory2: yup.string().required('Field is required'),
  brand: yup.string().required('Field is required'),
  manufacturer: yup.string().required('Field is required'),
  description: yup.string()
});

const RequestSkuModal = ({ open, onClose, selectedItem }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="request-sku-dialog"
      PaperProps={{
        className: classes.dialogRoot
      }}
      fullWidth
      maxWidth={'md'}
    >
      <DialogTitle id="request-sku-dialog" className={classes.dialogTitleContainer}>
        <div className="flex justify-between items-center py-2">
          <Typography><span className="font-bold ">REQUEST A SKU for: </span>{selectedItem}</Typography>
          <IconButton
            className="border-radius-4 p-2 bg-white border-1-muted"
            onClick={onClose}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <Formik
        initialValues={{
          revenueCategory1: '',
          revenueCategory2: '',
          brand: '',
          manufacturer: '',
          description: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values, {resetForm}) => {
          saveDataMappingRequestSkuEmailDataApi({dispatch, requestData: {...values, selectedItem}});
          resetForm();
          onClose();
        }}
      >
        {({ values, errors, touched, isValid, dirty, handleChange, handleBlur, handleSubmit }) => (
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <DialogContent className="px-8 pb-5">
              <Grid container spacing={3} className="flex items-center">
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name="revenueCategory1"
                    label="Revenue Category 1"
                    value={values.revenueCategory1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="dense"
                    error={touched.revenueCategory1 && !!errors.revenueCategory1}
                    helperText={
                      touched.revenueCategory1 && errors.revenueCategory1
                        ? errors.revenueCategory1
                        : 'e.g. Retail, Treatment, Surgical'
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name="revenueCategory2"
                    label="Revenue Category 2"
                    value={values.revenueCategory2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="dense"
                    error={touched.revenueCategory2 && !!errors.revenueCategory2}
                    helperText={
                      touched.revenueCategory2 && errors.revenueCategory2
                        ? errors.revenueCategory2
                        : 'e.g. Skincare, Injectable, Abdominal'
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name="brand"
                    label="Brand"
                    value={values.brand}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="dense"
                    error={touched.brand && !!errors.brand}
                    helperText={touched.brand && errors.brand}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    name="manufacturer"
                    label="Manufacturer"
                    value={values.manufacturer}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="dense"
                    error={touched.manufacturer && !!errors.manufacturer}
                    helperText={touched.manufacturer && errors.manufacturer}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="description"
                    label="Brief Description"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="dense"
                    multiline
                    rows={4}
                    error={touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={`justify-between py-6 ${classes.dialogActionContainer}`}>
              <Button
                variant="outlined"
                onClick={onClose}
                size="small"
                className="uppercase ml-5"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                size="small"
                disabled={!isValid && dirty}
                className="uppercase mr-5"
              >
                SEND REQUEST
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default RequestSkuModal;
